
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ask-for-referral",
      function () {
        return require("private-next-pages/ask-for-referral/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ask-for-referral"])
      });
    }
  